const EnumPeriodoAMePM = {
    MANHA: 'MANHÃ',
    TARDE: 'TARDE'
}
export default EnumPeriodoAMePM;